import { CSSObject } from '@chakra-ui/react';

export const Wrapper: CSSObject = {
  h: ['54px', null, '95px'],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const TextItem = {
  color: 'white',
  textAlign: 'center',
  fontSize: 'sm',
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 'normal',
};

export const LinkItem = {
  color: 'beta.400',
  fontWeight: 'bold',
};
